// extracted by mini-css-extract-plugin
module.exports = {"inputGrey":"Input_inputGrey__3Q8eo","text":"Input_text__1C--5","inputWhite":"Input_inputWhite__3V00M"};